module.exports = __webpack_public_path__ + "static/media/sample-mp4-file.5021b3b7.mp4";